var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 2.5A1.5 1.5 0 0 1 4 1h3.068H6.5v.5A2.5 2.5 0 0 0 9 4h.5v5.5A1.5 1.5 0 0 1 8 11H4a1.5 1.5 0 0 1-1.5-1.5zm6.826.5a1.5 1.5 0 0 0-.155-.235l-.96-1.202a1.5 1.5 0 0 0-.711-.49V1.5A1.5 1.5 0 0 0 9 3zM4 0a2.5 2.5 0 0 0-2.5 2.5v7A2.5 2.5 0 0 0 4 12h4a2.5 2.5 0 0 0 2.5-2.5V3.702a2.5 2.5 0 0 0-.548-1.562L8.991.938A2.5 2.5 0 0 0 7.039 0zm1 8a.5.5 0 0 1 .5-.5H8a.5.5 0 0 1 0 1H5.5A.5.5 0 0 1 5 8M4 5a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1zm-.5-1.5A.5.5 0 0 1 4 3h1.5a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5M7 9a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgFilesmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilesmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjUgMi41QzIuNSAxLjY3MTU3IDMuMTcxNTcgMSA0IDFINy4wMzg3NUw3LjA2NzgzIDEuMDAwMjhINi41VjEuNTAwMjhDNi41IDIuODgwOTkgNy42MTkyOSA0LjAwMDI4IDkgNC4wMDAyOEg5LjVWOS41QzkuNSAxMC4zMjg0IDguODI4NDMgMTEgOCAxMUg0QzMuMTcxNTcgMTEgMi41IDEwLjMyODQgMi41IDkuNVYyLjVaTTkuMzI1OTggMy4wMDAyOEM5LjI4MjE5IDIuOTE3NDggOS4yMzA0OSAyLjgzODUxIDkuMTcxMyAyLjc2NDUyTDguMjEwMDUgMS41NjI5NkM4LjAyNDM3IDEuMzMwODYgNy43NzY0NCAxLjE2MjAyIDcuNSAxLjA3MjY3VjEuNTAwMjhDNy41IDIuMzI4NzEgOC4xNzE1NyAzLjAwMDI4IDkgMy4wMDAyOEg5LjMyNTk4Wk00IDBDMi42MTkyOSAwIDEuNSAxLjExOTI5IDEuNSAyLjVWOS41QzEuNSAxMC44ODA3IDIuNjE5MjkgMTIgNCAxMkg4QzkuMzgwNzEgMTIgMTAuNSAxMC44ODA3IDEwLjUgOS41VjMuNzAxNTZDMTAuNSAzLjEzMzg4IDEwLjMwNjggMi41ODMxMSA5Ljk1MjE3IDIuMTM5ODJMOC45OTA5MiAwLjkzODI2M0M4LjUxNjQ5IDAuMzQ1MjI1IDcuNzk4MjEgMCA3LjAzODc1IDBINFpNNSA4QzUgNy43MjM4NiA1LjIyMzg2IDcuNSA1LjUgNy41SDhDOC4yNzYxNCA3LjUgOC41IDcuNzIzODYgOC41IDhDOC41IDguMjc2MTQgOC4yNzYxNCA4LjUgOCA4LjVINS41QzUuMjIzODYgOC41IDUgOC4yNzYxNCA1IDhaTTQgNUMzLjcyMzg2IDUgMy41IDUuMjIzODYgMy41IDUuNUMzLjUgNS43NzYxNCAzLjcyMzg2IDYgNCA2SDYuNUM2Ljc3NjE0IDYgNyA1Ljc3NjE0IDcgNS41QzcgNS4yMjM4NiA2Ljc3NjE0IDUgNi41IDVINFpNMy41IDMuNUMzLjUgMy4yMjM4NiAzLjcyMzg2IDMgNCAzSDUuNUM1Ljc3NjE0IDMgNiAzLjIyMzg2IDYgMy41QzYgMy43NzYxNCA1Ljc3NjE0IDQgNS41IDRINEMzLjcyMzg2IDQgMy41IDMuNzc2MTQgMy41IDMuNVpNNyA5QzYuNzIzODYgOSA2LjUgOS4yMjM4NiA2LjUgOS41QzYuNSA5Ljc3NjE0IDYuNzIzODYgMTAgNyAxMEg4QzguMjc2MTQgMTAgOC41IDkuNzc2MTQgOC41IDkuNUM4LjUgOS4yMjM4NiA4LjI3NjE0IDkgOCA5SDdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";